<template>
    <div class="principal">
        <NavBar :relatorios="true" :usarAberto="false" :usarHistorico="false" :usarVoltar="true" :usarDeslogar="false"
            :usarGerenciar="false" :usarRelatorio="false" :usarRelatorioEstrela="true" :usarRelatorioEstrelaAtend="true"
            :usarFiltros="true" :usarFiltroSetor="true" :usarFiltroTpChamado="true" :usarFiltroPosicao="true"
            :usarFiltroDatas="true" :usarFiltroTempo="true" :usarExportacao="true" @filtrar="filtrar" :tabela="true"
            :grafico="true" :visualizacaoPadrao="'Grafico'" @alterarVisualizacaoHistorico="alterarVisualizacaoHistorico"
            :usarTrocaVisualizacao="true" :card="true" :nomeTela="'Relatórios geral'" :usarAlterarRelatorio="true"
            @exportToPDF="exportToPDF" :formatarDataInicioMes="props.formatarDataInicioMes" @resetarTela="resetarTela" />
        <div class="row mb-5" v-if="state.historicoGeral == false">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6" v-if="state.relatorioGerado == true">
                <div v-show="state.tabela === 'Grafico'">
                    <canvas id="graficoRelatorioTempoMedioBarra" class="graficoRelatorio col-12"
                        style="height: 46vh;"></canvas>
                </div>
                <div v-show="state.tabela === 'Tabela'" style="min-height: 37vh;">
                    <div class="mainDiv" style="max-height: 37vh; overflow: auto;" ref="contentToExportTempoMedio">
                        <table class="table table-striped" v-show="state.tabela === 'Tabela'">
                            <thead>
                                <tr>
                                    <th class=" col-12 text-center fs-5" colspan="5">Tempo de Atendimento</th>
                                </tr>
                                <tr class="position-sticky" style="top: 0; background-color: var(--corBack);">
                                    <th class="col-sm-5 col-md-5 text-center">Setor</th>
                                    <th class="col-sm-1 col-md-1 text-center">Chamado</th>
                                    <th class="col-sm-1 col-md-1 text-center">Data</th>
                                    <th class="col-sm-1 col-md-1 text-center">Confirmados</th>
                                    <th class="col-sm-4 col-md-4 text-center">Tempo Médio</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(d, index) in state.dadosRelatorioTabelaTempoMedio" :key="index">
                                    <td class="col-sm-5 col-md-5">
                                        {{ d.setorDescricao }}
                                    </td>
                                    <td class="col-sm-1 col-md-1 text-center">
                                        {{ d.tipoChamadoDescricao }}
                                    </td>
                                    <td class="col-sm-1 col-md-1 text-center">
                                        {{ retornaDataFormatada(d.data) }}
                                    </td>
                                    <td class="col-sm-1 col-md-1 text-center">
                                        {{ d.qtdeConfirmados }}
                                    </td>
                                    <td class="col-sm-2 col-md-2 text-center">
                                        {{ converterHora(d.tempoMedio) || retornaPosicao(d.posicao) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-6 ps-0" v-if="state.relatorioGerado == true">
                <div v-show="state.tabela === 'Grafico'">
                    <canvas id="QtdeAtendParaEstrela" class="graficoRelatorio col-12" style="height: 46vh;"></canvas>
                </div>
                <div v-show="state.tabela === 'Tabela'" style="min-height: 37vh;">
                    <div class="mainDiv" style="max-height: 37vh; overflow: auto;" ref="contentToExportQtdeAtendEstrela">
                        <table class="table table-striped table-bordered" v-show="state.tabela === 'Tabela'">
                            <thead>
                                <tr>
                                    <th class="col-12 text-center fs-5" colspan="3">Pesquisa de Satisfação do Cliente</th>
                                </tr>
                                <tr class="position-sticky" style="top: 0; background-color: var(--corBack);">
                                    <th class="ps-4">Estrelas</th>
                                    <th class="ps-3 text-center">Porcentagem</th>
                                    <th class="ps-3 text-center">Confirmados</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(d, index) in state.dadosRelatorioTabelaQtdeAtendEstrela" :key="index">
                                    <td class="col-sm-6 col-md-6 text-center">
                                        <star-rating v-model:rating="d.estrelas" :read-only="true" :show-rating="false"
                                            :border-width="5" :star-size="30">
                                        </star-rating>
                                    </td>
                                    <td class="pt-2 ps-4 col-sm-2 col-md-2  text-center"> {{ d['porcentagem'] }}% </td>
                                    <td class="pt-2 ps-4 col-sm-2 col-md-2  text-center"> {{ d.qtdeConfirmados }} </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-6" v-if="state.relatorioGerado == true">
                <div v-show="state.tabela === 'Grafico'">
                    <canvas id="graficoRelatorioAtendTempo" class="graficoRelatorio col-12" style="height: 46vh;"></canvas>
                </div>
                <div v-show="state.tabela === 'Tabela'" style="min-height: 37vh;">
                    <div class="mainDiv" style="max-height: 37vh; overflow: auto;" ref="contentToExportOrdenadoAtendTempo">
                        <table class="table table-striped" v-show="state.tabela === 'Tabela'">
                            <thead>
                                <tr>
                                    <th class="col-12 text-center fs-5" colspan="2">Atendimento ao Longo do Tempo</th>
                                </tr>
                                <tr class="position-sticky" style="top: 0; background-color: var(--corBack);">
                                    <th class="">Setor</th>
                                    <th class="">Dia</th>
                                    <th class="">Atendimentos</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(d, index) in state.dadosRelatorioTabelaOrdenadoAtendTempo" :key="index">
                                    <td class="">{{ d.setor }}</td>
                                    <td class="">{{ retornaDataFormatada(d.data) }}</td>
                                    <td class="">{{ d.qtdeAtend }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-6 ps-0" v-if="state.relatorioGerado == true">
                <div v-show="state.tabela === 'Grafico'">
                    <canvas id="MediaAvaliacaoSetorBarra" class="graficoRelatorio col-12" style="height: 46vh;">
                        Media Avaliação por Setor
                    </canvas>
                </div>
                <div v-show="state.tabela === 'Tabela'" style="min-height: 37vh;">
                    <div class="mainDiv" style="max-height: 37vh; overflow: auto;" ref="contentToExportMediaAvaliacaoSetor">
                        <table class="table table-striped" v-show="state.tabela === 'Tabela'">
                            <thead>
                                <tr>
                                    <th class="col-12 text-center fs-5" colspan="4">Avaliação do Cliente por Setor</th>
                                </tr>
                                <tr class="position-sticky" style="top: 0; background-color: var(--corBack);">
                                    <th class="col-sm-4 col-md-4 text-center">Setor</th>
                                    <th class="col-sm-2 col-md-2 text-center">Atendimento</th>
                                    <th class="col-sm-2 col-md-2 text-center">Media das Avaliações</th>
                                    <th class="col-sm-2 col-md-2 text-center">Porcentagem</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(d, index) in state.dadosRelatorioTabelaMediaAvaliacaoSetor" :key="index">
                                    <td class="col-sm-4 col-md-4 text-center"> {{ d['setorDescricao'] }} </td>
                                    <td class="col-sm-2 col-md-2 text-center"> {{ d['quantidadeAvaliacoes'] }} </td>
                                    <td class="col-sm-4 col-md-4 text-center"> {{ d['mediaAvaliacoes'] }} </td>
                                    <td class="col-sm-2 col-md-2 text-center"> {{ d['mediaAvaliacoesPorcentagem'] }}% </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="mainDiv" v-show="state.historicoGeral == true">
            <div class="displayflex flex-wrap jContent gap-3 mb-1" ref="contentToExportCardHistoricoGeral"
                v-show="(state.existeErro != true) && (state.card === 'Card') && state.chamados.length >= 1">
                <Card v-for="dChamado in state.chamados" :key="dChamado.id" :dChamado="dChamado" :tpChamado="tipoChamado" />
            </div>
            <div class="w-100 mb-5" ref="contentToExportGridHistoricoGeral"
                v-show="(state.existeErro != true) && (state.card === 'Tabela') && state.chamados.length >= 1">
                <Grid :dChamado="state.chamados" :tpChamado="tipoChamado" @carregarChamados="carregarChamados" />
            </div>
        </div>
    </div>
    <ModalEditar :mostrar="state.existeErro" :tamanhoModal="30">
        <template v-slot:header>
            <p class="fs-4">
                {{ state.titulo }}
            </p>
        </template>
        <template v-slot:corpo>
            <p class="fs-5">
                {{ state.textoErro }}
            </p>
        </template>
        <template v-slot:rodape>
            <button @click="desativarModal()" class="btn btn-primary">Entendi</button>
        </template>
    </ModalEditar>

    <ModalEditar :mostrar="state.mostrarModalAtendTempo" :modalLargo="true" :tamanhoModal="80" :relatorio="true">
        <template v-slot:header>
            <h2>Tempo Médio</h2>
        </template>
        <template v-slot:corpo>
            <Grid :dChamado="state.dadoModalAtendTempo" />
        </template>
        <template v-slot:rodape>
            <button class="btn btn-secondary" @click="fecharModal()">Fechar</button>
        </template>
    </ModalEditar>

    <ModalEditar :mostrar="state.mostrarModalQtdeAtendEstrela" :modalLargo="true" :tamanhoModal="80" :relatorio="true">
        <template v-slot:header>
            <h2>Motivos</h2>
            <div class="w-100 justify-content-center mb-1 d-flex fundoNav">
                <!-- <div class="w-50"> -->
                <label class="lblTelaMenor chamado" style="min-width: 150px">
                    <p class="ms-3" style="font-size: 1.1rem; text-align: start">Justificativa</p>
                </label>
                <select class="form-select" style="width: 200px" v-model="state.justificativa" @change="resetarMotivo()">
                    <option value="T">Todos</option>
                    <option value="N">Não Justificado</option>
                    <option value="J">Justificado</option>
                </select>
                <div class="divGerar ms-2">
                    <div class="botaoGerar">
                        <button @click="filtrarMotivos()" class="btn-filtrar" style="height: 50px;">Gerar</button>
                    </div>
                </div>
                <!-- </div> -->
                <!-- <div class="w-25 d-flex justify-content-end">
                </div> -->
            </div>
        </template>
        <template v-slot:corpo>
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th class="col-sm-2 col-md-2">Quarto</th>
                        <th class="col-sm-2 col-md-2">Leito</th>
                        <th class="col-sm-2 col-md-2">Chamado</th>
                        <th class="col-sm-1 col-md-1">Data</th>
                        <th class="col-sm-8 col-md-8">Motivo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, index) in state.dadoModalQtdeAtendEstrela" :key="index">
                        <td class="col-sm-2 col-md-2"> {{ d.quarto }} </td>
                        <td class="col-sm-2 col-md-2"> {{ d.leito }} </td>
                        <td class="col-sm-2 col-md-2"> {{ d.chamadoDescricao }} </td>
                        <td class="col-sm-1 col-md-1"> {{ retornaDataFormatada(d.data) }} </td>
                        <td class="col-sm-8 col-md-8" v-show="d.motivo === null"> Não Justificado </td>
                        <td class="col-sm-8 col-md-8" v-show="d.motivo !== null"> {{ d.motivo }} </td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template v-slot:rodape>
            <button class="btn btn-secondary" @click="fecharModal()">Fechar</button>
        </template>
    </ModalEditar>

    <ModalEditar :mostrar="state.mostrarModalTempoMedio" :modalLargo="true" :tamanhoModal="80" :relatorio="true">
        <template v-slot:header>
            <h2>Tempo Médio</h2>
        </template>
        <template v-slot:corpo>
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>Setor</th>
                        <th>Tempo médio</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, index) in state.dadoModalTempoMedio" :key="index">
                        <td>{{ d.setorDescricao }}</td>
                        <td>{{ converterHora(d.tempoMedio) }}</td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template v-slot:rodape>
            <button class="btn btn-secondary" @click="fecharModal()">Fechar</button>
        </template>
    </ModalEditar>

    <ModalEditar :mostrar="state.atualizandoDados" :tamanhoModal="40" :relatorio="true">
        <template v-slot:header>
            <p class="p-0"> {{ state.msgAtualizandoDados }}</p>
        </template>
        <template v-slot:corpo>
            <!-- <p class="p-0"></p> -->
            <div class="d-flex justify-content-center">
                <img src="../assets/gifs/greenloading.gif" alt="">
            </div>
        </template>
    </ModalEditar>
</template>

<script setup>
/* eslint-disable */
import NavBar from '@/components/NavBar.vue';
import moment from 'moment';
import { Chart, CategoryScale, BarController, BarElement, Title, LineController, LinearScale, PieController, ArcElement, DoughnutController, LineElement, PointElement } from "chart.js";
import { computed, defineProps, onMounted, reactive, ref } from 'vue';
import api from '@/api/api';
import store from "@/store/store";
import StarRating from 'vue-star-rating';
import ModalEditar from '@/components/ModalEditar.vue';
import Grid from '@/components/Grid.vue';
import Card from '@/components/Card.vue';
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf';

const props = defineProps(['formatarDataInicioMes']);

const state = reactive({
    tabela: String('Grafico'),
    card: String("Card"),
    titulo: String(),
    textoErro: String(),
    existeErro: Boolean(),
    visualizacaoDeGraficos: Boolean(),
    historicoGeral: Boolean(false),

    valorFiltroSetor: Number(0),
    valorFiltroTPChamado: Number(0),
    valorFiltroQuarto: Number(0),
    valorFiltroLeito: Number(0),
    valorFiltroPosicao: String(),
    valorFiltroDataInicial: String(),
    valorFiltroDataFinal: String(),
    valorFiltroVisualizacao: String(),
    valorFiltroDuracao: String(),
    valorOrderData: String(),
    valorOrderHora: String(),
    chamados: Array(),

    dados: Array(),
    lstSetor: Array(),
    lstSetorDesc: Array(),
    lstTpChamado: Array(),
    lstTpChamadoDesc: Array(),

    dadosRelatorioTabelaTempoMedio: Array(),
    dadoModalTempoMedio: Array(),
    graficoTempoMedioPizza: String(),
    graficoTempoMedioBarras: String(),
    mostrarModalTempoMedio: Boolean(),
    // mostrarModalTempoMedioBarra: Boolean(),
    // mostrarModalTempoMedioPizza: Boolean(),

    dadosRelatorioTabelaQtdeAtendEstrela: Array(),
    dadoModalQtdeAtendEstrela: Array(),
    graficoQtdeAtendEstrela: String(),
    filtroTpChamado: Boolean(),
    mostrarModalQtdeAtendEstrela: Boolean(),
    justificativa: String("T"),
    numeroEstrelas: Number(),

    dataUSA: Array(),
    dadosRelatorioTabelaAtendTempo: Array(),
    dadosRelatorioTabelaOrdenadoAtendTempo: Array(),
    dadoModalAtendTempo: Array(),
    graficoAtendTempo: String(),
    mostrarModalAtendTempo: Boolean(),

    dadosRelatorioTabelaMediaAvaliacaoSetor: Array(),
    dadoModalMediaAvaliacaoSetor: Array(),
    dadosHora: Array(),
    graficoMediaAvaliacaoSetorBarra: String(),

    atualizandoDados: Boolean(),
    msgAtualizandoDados: String(),

    relatorioGerado: Boolean(),

    usarPosicaoAberto: Boolean(),
    usarPosicaoAdministrativo: Boolean(),
    usarPosicaoFechado: Boolean(),
    usarPosicaoCancelado: Boolean(),
});

//#region Gráficos e Tabelas dos Relatórios

//#region Tempo Médio

async function construirTabelaTempoMedio(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal,
    pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado) {
    if (retornaData(pDataInicial) > retornaData(pDataFinal)) {
        state.titulo = "Aviso";
        state.textoErro = "A Data Inicial não pode ser maior que a Data Final";
        state.existeErro = true;
    } else {
        let auxDataInicial = moment(pDataInicial).format("DD.MM.YYYY");
        let auxDataFinal = moment(pDataFinal).format("DD.MM.YYYY");

        let sql = "SELECT * FROM P_CHAMADO_MEDIA P";
        sql += ` WHERE P.OUT_DATA BETWEEN '${auxDataInicial}' AND '${auxDataFinal}' `;
        if (String(pValorDuracao).trim() == "1") {
            sql += ` AND P.OUT_TEMPO_ATEND >= 7200`;
        } else if (String(pValorDuracao).trim() != "0" && String(pValorDuracao).trim() != "1" && String(pValorDuracao).trim() != "") {
            sql += ` AND P.OUT_TEMPO_ATEND BETWEEN ${pValorDuracao}`;
        }
        sql += ` ORDER BY P.OUT_DATA DESC`;

        // let sql = `SELECT C.DATA, S.ID, S.DESCRICAO SETOR, T.ID, T.DESCRICAO, 'quantidade' ,

        // CASE 
        //     WHEN C.DTFINALIZACAO IS NOT NULL 
        //         THEN  DATEDIFF (SECOND , 
        //                         CAST(EXTRACT(DAY FROM C.DATA) || '.' || EXTRACT(MONTH FROM C.DATA) || '.' || EXTRACT(YEAR FROM C.DATA) || ',' || C.HORA AS TIMESTAMP), 
        //                         CAST(EXTRACT(DAY FROM C.DTFINALIZACAO) ||' .'|| EXTRACT(MONTH FROM C.DTFINALIZACAO) || '.' || EXTRACT(YEAR FROM C.DTFINALIZACAO) || ',' ||C.HRFINALIZACAO AS TIMESTAMP)
        //                     )

        //     WHEN C.DTCANCELAMENTO IS NOT NULL
        //         THEN DATEDIFF (SECOND , 
        //                         CAST(EXTRACT(DAY FROM C.DATA) || '.' || EXTRACT(MONTH FROM C.DATA) || '.' || EXTRACT(YEAR FROM C.DATA) || ',' || C.HORA AS TIMESTAMP), 
        //                         CAST(EXTRACT(DAY FROM C.DTCANCELAMENTO) || '.' || EXTRACT(MONTH FROM C.DTCANCELAMENTO) || '.' || EXTRACT(YEAR FROM C.DTCANCELAMENTO) || ',' || C.HRCANCELAMENTO AS TIMESTAMP)
        //                     )

        // END, T.COR, C.POSICAO

        // FROM CHAMADO C
        // JOIN TIPO_CHAMADO T ON T.ID = C.ID_TIPO_CHAMADO
        // JOIN LEITO L ON L.ID = C.ID_LEITO
        // JOIN QUARTO Q ON Q.ID = L.ID_QUARTO
        // JOIN SETOR S ON S.ID = Q.ID_SETOR `;

        // sql += ` WHERE C.DATA BETWEEN '${auxDataInicial}' AND '${auxDataFinal}' `;


        // if (pUsarPosicaoAberto == true) {
        //     sql += " AND ( ";

        //     sql += ` C.POSICAO = 'AB' `;

        //     if (pUsarPosicaoCancelado == false && pUsarPosicaoFechado == false && pUsarPosicaoAdministrativo == false)
        //         sql += " ) ";
        //     else if (pUsarPosicaoCancelado == true || pUsarPosicaoFechado == true || pUsarPosicaoAdministrativo == true)
        //         sql += " OR ";
        // }

        // if (pUsarPosicaoAdministrativo == true) {
        //     if (pUsarPosicaoAberto == false)
        //         sql += " AND ( ";

        //     sql += ` C.POSICAO = 'AD' `;

        //     if (pUsarPosicaoCancelado == false && pUsarPosicaoFechado == false)
        //         sql += " ) ";
        //     else if (pUsarPosicaoCancelado == true || pUsarPosicaoFechado == true)
        //         sql += " OR ";
        // }

        // if (pUsarPosicaoFechado == true) {
        //     if (pUsarPosicaoAberto == false && pUsarPosicaoAdministrativo == false)
        //         sql += " AND ( ";

        //     sql += ` C.POSICAO = 'FE' `;

        //     if (pUsarPosicaoCancelado == false)
        //         sql += " ) ";
        //     else if (pUsarPosicaoCancelado == true)
        //         sql += " OR ";
        // }

        // if (pUsarPosicaoCancelado == true) {
        //     if (pUsarPosicaoAberto == false && pUsarPosicaoAdministrativo == false && pUsarPosicaoCancelado == false)
        //         sql += " AND ( ";

        //     sql += ` C.POSICAO = 'CA' `;

        //     sql += " ) ";
        // }

        // if (pValorFiltroSetor > 0) {
        //     sql += ` AND S.ID = ${pValorFiltroSetor}`;
        // }

        // if (pValorFiltroSetor > 0) {
        //     sql += ` AND C.ID_TIPO_CHAMADO = ${pValorFiltroTPChamado}`;
        // }

        // sql += ` ORDER BY C.ID`;


        await api.listarSql(sql)
            .then(resp => {
                state.dadosRelatorioTabelaTempoMedio = [];
                resp.forEach((r) => {
                    // console.log(r);
                    if (isNaN(pValorFiltroSetor)) {
                        if (pValorFiltroSetor == "AD" && pValorFiltroTPChamado == 0) {
                            (r[8] === "AD") ? montarObjetoTabela(r) : "";
                            return;
                        }
                        if (pValorFiltroSetor == "AD" && pValorFiltroTPChamado > 0) {
                            (pValorFiltroTPChamado === r[3] && r[8] === "AD") ? montarObjetoTabela(r) : "";
                            return;
                        }
                    } else {
                        if (pValorFiltroSetor == 0 && pValorFiltroTPChamado == 0) {
                            montarObjetoTabela(r);
                            return;
                        }
                        if (pValorFiltroSetor > 0 && pValorFiltroTPChamado > 0) {
                            (pValorFiltroSetor === r[1] && pValorFiltroTPChamado === r[3]) ? montarObjetoTabela(r) : "";
                            return;
                        }
                        if (pValorFiltroSetor > 0 && pValorFiltroTPChamado == 0) {
                            (pValorFiltroSetor === r[1]) ? montarObjetoTabela(r) : "";
                            return;
                        }
                        if (pValorFiltroSetor == 0 && pValorFiltroTPChamado > 0) {
                            (pValorFiltroTPChamado === r[3]) ? montarObjetoTabela(r) : "";
                            return;
                        }
                    }
                });
            });
    }
}

function montarObjetoTabela(pObjAux) {
    // console.log(pObjAux);
    let aux = {};
    aux['data'] = pObjAux[0];
    aux['idSetor'] = pObjAux[1];
    aux['setorDescricao'] = pObjAux[2];
    aux['idTipoChamado'] = pObjAux[3];
    aux['tipoChamadoDescricao'] = pObjAux[4];
    aux['qtdeConfirmados'] = pObjAux[5];
    aux['tempoMedio'] = pObjAux[6];
    aux['cor'] = pObjAux[7];
    aux['posicao'] = pObjAux[8];
    state.dadosRelatorioTabelaTempoMedio.push(aux);
}

function converterHora(pSegundos) {
    // console.log(pSegundos);
    let horaFinal = "", auxDia = 0, auxHora = 0, auxMinuto = 0, auxSegundo = pSegundos;

    while (auxSegundo >= 60) {
        auxMinuto++;
        auxSegundo = auxSegundo - 60;
    }

    while (auxMinuto >= 60) {
        auxHora++;
        auxMinuto -= 60;
    }

    while (auxHora >= 24) {
        auxDia++;
        auxHora -= 24;
    }

    if (auxDia > 0) {
        horaFinal += auxDia + "d ";
    }

    if (auxHora > 0) {
        horaFinal += auxHora + "h ";
    }

    if (auxMinuto > 0) {
        horaFinal += auxMinuto + "m ";
    }

    if (Number(auxSegundo).toFixed(0) > 0) {
        horaFinal += Number(auxSegundo).toFixed(0) + "s ";
    }

    return horaFinal;
}

async function montarObjetoGrafico(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pValorDuracao) {
    let sql = "";
    let auxDataInicial = moment(pDataInicial).format("DD.MM.YYYY");
    let auxDataFinal = moment(pDataFinal).format("DD.MM.YYYY");

    sql += `SELECT `;

    if (state.visualizacaoDeGraficos) {
        sql += `c.HrFinalizacao, c.DtFinalizacao, c.Hora, c.Data, c.Leito.Quarto.Setor.ID, c.Leito.Quarto.Setor.DESCRICAO, c.Leito.Quarto.Setor.DESCRICAO `;
    } else {
        sql += `c.HrFinalizacao, c.DtFinalizacao, c.Hora, c.Data, c.TipoChamado.Id, c.TipoChamado.Descricao, c.TipoChamado.Cor `;
    }

    sql += `FROM Chamado c WHERE (c.Posicao = 'FE' `;

    if (pValorFiltroTPChamado != 0) {
        sql += `AND c.TipoChamado.Id = ${pValorFiltroTPChamado} `;
    }

    if (pValorFiltroSetor != 0) {
        sql += `AND c.Leito.Quarto.Setor.Id = ${pValorFiltroSetor} `;
    }

    sql += retornaSqlDuracao(pValorDuracao, true);

    sql += ` AND c.Data between '${auxDataInicial}' and '${auxDataFinal}')`;
    await api.listarHQL(sql)
        .then(resp => {
            let qtdeH = 0, qtdeE = 0, qtdeU = 0;
            let tempoH = 0, tempoE = 0, tempoU = 0;

            resp.forEach((r) => {
                if (r[5] == "Hotelaria") {
                    tempoH += calcularDiferencaDeTempo(r[3].replace('00:00:00', r[2]), r[1].replace('00:00:00', r[0])) / 1000;
                    qtdeH++;
                }
                if (r[5] == "Enfermagem") {
                    tempoE += calcularDiferencaDeTempo(r[3].replace('00:00:00', r[2]), r[1].replace('00:00:00', r[0])) / 1000;
                    qtdeE++;
                }
                if (r[5] == "Urgência") {
                    tempoU += calcularDiferencaDeTempo(r[3].replace('00:00:00', r[2]), r[1].replace('00:00:00', r[0])) / 1000;
                    qtdeU++;
                }
            });

            state.dadosHora = [];

            state.lstTpChamado.forEach((t) => {
                // console.log(t);
                let aux = {};
                if (t.descricao == "Hotelaria") {
                    aux['hora'] = tempoH;
                    aux['id'] = t.id;
                    aux['qtdeConf'] = qtdeH;
                    aux['descricao'] = t.descricao;
                    aux['cor'] = t.cor;
                }
                if (t.descricao == "Enfermagem") {
                    aux['hora'] = tempoE;
                    aux['id'] = t.id;
                    aux['qtdeConf'] = qtdeE;
                    aux['descricao'] = t.descricao;
                    aux['cor'] = t.cor;
                }
                if (t.descricao == "Urgência") {
                    aux['hora'] = tempoU;
                    aux['id'] = t.id;
                    aux['qtdeConf'] = qtdeU;
                    aux['descricao'] = t.descricao;
                    aux['cor'] = t.cor;
                }
                state.dadosHora.push(aux);
            });
        });
}

async function construirGraficoPizzaTempoMedio() {
    const graficoRelatorioTempoMedioPizza = document.getElementById("graficoRelatorioTempoMedioPizza").getContext("2d");
    if (state.graficoTempoMedioPizza) {
        state.graficoTempoMedioPizza.destroy();
    }

    let setoresDesc = [];
    state.dadosRelatorioTabelaTempoMedio.forEach((d) => {
        setoresDesc.push(d.setorDescricao);
    });

    let lstTempo = [(state.dadosHora[0]?.hora / state.dadosHora[0]?.qtdeConf).toFixed(0), (state.dadosHora[1]?.hora / state.dadosHora[1]?.qtdeConf).toFixed(0), (state.dadosHora[2]?.hora / state.dadosHora[2]?.qtdeConf).toFixed(0)];
    let lstCores = [state.dadosHora[0]?.cor, state.dadosHora[1]?.cor, state.dadosHora[2]?.cor];

    setoresDesc = [...new Set(setoresDesc)];

    let conversaoParaHora = converterHora;

    const hoverValue = {
        id: 'hoverValue',
        afterDatasetsDraw(chart) {
            const { ctx, data, options } = chart;
            chart.getActiveElements().forEach((active) => {
                let value = Number(data.datasets[active.datasetIndex].data[active.index]).toFixed(0);
                const fontSize = options.hoverRadius;
                value = conversaoParaHora(value);
                ctx.save();
                ctx.textAlign = 'center';
                ctx.font = `bold ${fontSize}px sans-serif`;
                ctx.lineDashOffset = 10;
                ctx.fillText(value, active.element.x, 160);
                ctx.restore();
            });
        }
    };

    state.graficoTempoMedioPizza = new Chart(graficoRelatorioTempoMedioPizza, {
        type: "pie",
        data: {
            labels: state.lstTpChamadoDesc,
            datasets: [
                {
                    label: lstTempo,
                    data: lstTempo,
                    backgroundColor: lstCores,
                    hoverOffset: 4,
                    hoverBorderWidth: 2
                },
            ],
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            hoverRadius: 20,
            plugins: {
                title: {
                    display: true,
                    text: 'Tempo Médio por Tipo de Chamado',
                    padding: {
                        top: 10,
                        bottom: 30
                    },
                    font: {
                        size: 20
                    }
                }
            },
            onClick: async (e) => {
                // let aux = [];
                // this.lstTpChamado.forEach((l) => {
                //     this.dadoModal.push({
                //         'chamadoDescricao': l,
                //         'tempoMedio': 0
                //     });
                //     aux[l] = 0;
                // });
                // let tempo = e.chart.data.datasets[0].data;

                // tempo.forEach((t, index) => {
                //     this.dadoModal[index].tempoMedio = t;
                // });

                // this.mostrarModalPizza = true;
            },
            animation: {
                duration: 1000
            }
        },
        plugins: [hoverValue]
    });
}

async function construirGraficoBarraTempoMedio() {
    let graficoRelatorioTempoMedioBarra = document.getElementById("graficoRelatorioTempoMedioBarra").getContext("2d");
    if (state.graficoTempoMedioBarras) {
        state.graficoTempoMedioBarras.destroy();
    }

    let lstTempo = new Object();
    let aux = new Object();
    let setoresDesc = [];
    let lstCores = [state.dadosHora[0]?.cor, state.dadosHora[1]?.cor, state.dadosHora[2]?.cor];

    // console.log(state.dadosHora);

    state.dadosHora.forEach((d) => {
        if (lstTempo[d.descricao] == undefined) {
            lstTempo[d.descricao] = 0;
        }
        if (aux[d.descricao] == undefined) {
            aux[d.descricao] = 0;
        }
        setoresDesc.push(d.descricao);
        aux[d.descricao]++;
    });

    setoresDesc = [...new Set(setoresDesc)];

    setoresDesc.forEach((d, index) => {
        lstTempo[d] = Number((state.dadosHora[index].hora /= state.dadosHora[index].qtdeConf).toFixed(0));
    });

    let conversaoParaHora = converterHora;

    const hoverValue = {
        id: 'hoverValue',
        afterDatasetsDraw(chart) {
            const { ctx, data, options } = chart;
            chart.getActiveElements().forEach((active) => {
                let value = data.datasets[active.datasetIndex].data[data.labels[active.index]].toFixed(0);// + "s";
                const fontSize = options.hoverRadius;
                value = conversaoParaHora(value);
                ctx.save();
                ctx.textAlign = 'center';
                ctx.font = `bold ${fontSize}px sans-serif`;
                ctx.lineDashOffset = 10;
                ctx.fillText(value, active.element.x, active.element.y);
                ctx.restore();
            });
        },
    };

    if (state.dadosRelatorioTabelaTempoMedio.length > 0) {
        state.graficoTempoMedioBarras = new Chart(graficoRelatorioTempoMedioBarra, {
            type: "bar",
            data: {
                labels: setoresDesc,
                datasets: [
                    {
                        label: lstTempo,
                        data: lstTempo,
                        backgroundColor: lstCores,
                        borderColor: ['rgb(255, 99, 132)'],
                        maxBarThickness: 35,
                        fill: false,
                        barPercentage: 0.5,
                        hoverOffset: 4
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                hoverRadius: 20,
                plugins: {
                    title: {
                        display: true,
                        text: 'Tempo de Atendimento',
                        padding: {
                            top: 10,
                            bottom: 30
                        },
                        font: {
                            size: 20
                        }
                    },
                },
                scales: {
                    y: {
                        ticks: {
                            callback: (value) => {
                                let aux = value, i = 0, filtrado = false;
                                if (aux >= 60) {
                                    while (aux >= 60) {
                                        aux -= 60;
                                        i++;
                                    }
                                    if (i != 0) {
                                        return converterHora(60 * i);
                                    }
                                    filtrado = true;
                                }
                                if (aux >= 5 && filtrado == false) {
                                    while (aux >= 5) {
                                        aux -= 5;
                                        i++;
                                    }
                                    if (i != 0) {
                                        return converterHora(5 * i);
                                    }
                                }
                            }
                        },
                    }
                },
                onClick: async (e) => {
                    let setores = e.chart.data.labels;

                    setores.forEach((l) => {
                        state.dadoModalTempoMedio.push({
                            'setorDescricao': l,
                            'tempoMedio': 0
                        });
                    });

                    state.dadoModalTempoMedio.forEach((m) => {
                        m.tempoMedio = lstTempo[m.setorDescricao];
                    });

                    state.mostrarModalTempoMedio = true;
                },
                animation: {
                    duration: 1000
                }
            },
            plugins: [hoverValue]
        });
        Chart.defaults.font.size = 18;
    }
}

function retornaPosicao(pParam) {
    let nomeCompleto;
    switch (pParam) {
        case "AB":
            nomeCompleto = "Aberto";
            break;
        case "AD":
            nomeCompleto = "Administrativo";
            break;
        case "FE":
            nomeCompleto = "Fechado";
            break;
        case "CA":
            nomeCompleto = "Cancelado";
            break;
    }
    return nomeCompleto;
}

//#endregion

//#region Avaliação do Cliente por Setor 

async function construirTabelaMediaAvaliacaoSetor(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pValorDuracao) {
    let sql = `SELECT 
                       S.DESCRICAO SETOR, S.ID , count(*) , sum(C.AVALIACAO) , avg(C.AVALIACAO), list(C.AVALIACAO) , 
                       (100 * avg(C.AVALIACAO) / 5.0) || '%'
                       FROM CHAMADO C 
                       JOIN TIPO_CHAMADO T ON T.ID = C.ID_TIPO_CHAMADO
                       JOIN LEITO L ON L.ID = C.ID_LEITO 
                       JOIN QUARTO Q ON Q.ID = L.ID_QUARTO 
                       JOIN SETOR S ON S.ID = Q.ID_SETOR 
                       WHERE 
                       C.POSICAO = 'FE' AND C.AVALIACAO> 0
                      `;
    (pValorFiltroSetor > 0) ? sql += `AND S.ID = ${pValorFiltroSetor} ` : "";

    (pValorFiltroTPChamado > 0) ? sql += `AND T.ID = ${pValorFiltroTPChamado} ` : "";

    sql += retornaSqlDuracao(pValorDuracao);

    if (retornaData(pDataInicial) > retornaData(pDataFinal)) {
        state.titulo = "Aviso";
        state.textoErro = "A Data Inicial não pode ser maior que a Data Final";
        state.existeErro = true;
    } else {
        let auxDataInicial = moment(pDataInicial).format("DD.MM.YYYY");
        let auxDataFinal = moment(pDataFinal).format("DD.MM.YYYY");
        sql += `AND C.DATA between '${auxDataInicial}' and '${auxDataFinal}'
                        group by 1,2`;
        await api.listarSql(sql)
            .then(resp => {
                state.dadosRelatorioTabelaMediaAvaliacaoSetor = [];
                resp.forEach((r) => {
                    let aux = {};
                    aux["setorDescricao"] = r[0];
                    aux["idSetor"] = r[1];
                    aux["quantidadeAvaliacoes"] = r[2];
                    aux["somaAvaliacoes"] = r[3];
                    aux["mediaAvaliacoes"] = r[4];
                    aux["listagemAvaliacoes"] = r[5];
                    aux["mediaAvaliacoesPorcentagem"] = parseFloat(r[6]).toFixed(2);
                    state.dadosRelatorioTabelaMediaAvaliacaoSetor.push(aux);
                });

                document.querySelectorAll("svg.vue-star-rating-star").forEach((s) => {
                    // s.width.animVal.value = 30
                    // s.width.baseVal.value = 30
                    // s.height.animVal.value = 30
                    // s.height.baseVal.value = 30
                    // console.log(s.width);
                });
            });
    }
}

async function construirGraficoMediaAvaliacaoSetor() {
    let graficoMediaAvaliacaoSetorBarra = document.querySelector("#MediaAvaliacaoSetorBarra").getContext("2d");
    if (state.graficoMediaAvaliacaoSetorBarra) {
        state.graficoMediaAvaliacaoSetorBarra.destroy();
    }

    let setoresDesc = [];
    let media = [];

    state.dadosRelatorioTabelaMediaAvaliacaoSetor.forEach((d) => {
        setoresDesc.push(d.setorDescricao);
        media.push(d.mediaAvaliacoes);
    });

    media.push(5);
    setoresDesc = [...new Set(setoresDesc)];

    const hoverValue = {
        id: 'hoverValue',
        afterDatasetsDraw(chart) {
            const { ctx, data, options } = chart;
            chart.getActiveElements().forEach((active) => {
                const value = data.datasets[active.datasetIndex].data[active.index].toFixed(0) + "★";
                const fontSize = options.hoverRadius;
                ctx.save();
                ctx.textAlign = 'center';
                ctx.font = `bold ${fontSize}px sans-serif`;
                ctx.lineDashOffset = 10;
                ctx.fillText(value, active.element.x, active.element.y);
                ctx.restore();
            });
        }
    };

    if (state.dadosRelatorioTabelaMediaAvaliacaoSetor.length > 0) {
        state.graficoMediaAvaliacaoSetorBarra = new Chart(graficoMediaAvaliacaoSetorBarra, {
            type: "bar",
            data: {
                labels: setoresDesc,
                datasets: [{
                    label: 'My First Dataset',
                    data: media,
                    maxBarThickness: 35,
                    backgroundColor: ['rgba(255, 99, 132, 0.2)'],
                    borderColor: ['rgb(255, 99, 132)'],
                    borderWidth: 1
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: "x",
                hoverRadius: 20,
                plugins: {
                    title: {
                        display: true,
                        text: 'Avaliação do Cliente por Setor',
                        padding: {
                            top: 10,
                            bottom: 30
                        },
                        font: {
                            size: 20
                        }
                    }
                }
            },
            plugins: [hoverValue]
        });
    }
}

//#endregion

//#region Pesquisa de Satisfação do Cliente

async function construirTabelaAtendEstrela(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pValorDuracao) {
    let sql = `SELECT C.AVALIACAO, count(*) 
FROM CHAMADO C 
JOIN TIPO_CHAMADO T ON T.ID = C.ID_TIPO_CHAMADO 
JOIN LEITO L ON L.ID = C.ID_LEITO 
JOIN QUARTO Q ON Q.ID = L.ID_QUARTO 
JOIN SETOR S ON S.ID = Q.ID_SETOR 
WHERE 
C.POSICAO = 'FE' AND C.AVALIACAO > 0 `;
    if (retornaData(pDataInicial) > retornaData(pDataFinal)) {
        state.titulo = "Aviso";
        state.textoErro = "A Data Inicial não pode ser maior que a Data Final";
        state.existeErro = true;
    } else {
        if (pValorFiltroSetor > 0) {
            sql += `AND S.ID=${pValorFiltroSetor} `;
        }
        if (pValorFiltroTPChamado > 0) {
            sql += `AND C.ID_TIPO_CHAMADO=${pValorFiltroTPChamado} `;
        }
        let auxDataInicial = retornaDataSql(pDataInicial);
        let auxDataFinal = retornaDataSql(pDataFinal);
        sql += ` AND C.DATA between '${auxDataInicial}' and '${auxDataFinal}'
                `;
        sql += retornaSqlDuracao(pValorDuracao);
        sql += ` group by 1 `;
        await api.listarSql(sql)
            .then(resp => {
                state.dadosRelatorioTabelaQtdeAtendEstrela = [];
                console.log(resp);
                let total = 0;
                resp.forEach((r) => {
                    let aux = {};
                    aux['estrelas'] = r[0];
                    aux['qtdeConfirmados'] = r[1];
                    total += r[1];
                    state.dadosRelatorioTabelaQtdeAtendEstrela.push(aux);
                });
                state.dadosRelatorioTabelaQtdeAtendEstrela.forEach(d => {
                    let aux = parseFloat((d.qtdeConfirmados / total) * 100).toFixed(2);
                    d['porcentagem'] = aux;
                });
            });
    }
}

async function construirGraficoAtendEstrela(auxDataInicial, auxDataFinal) {
    const graficoQtdeAtendEstrela = document.querySelector("#QtdeAtendParaEstrela").getContext("2d");
    if (state.graficoQtdeAtendEstrela) {
        state.graficoQtdeAtendEstrela.destroy();
    }

    let estrelas = [];
    let confirmados = [];
    let porcentagens = [];
    let bgColor = 'rgba(255, 99, 132, 0.2)';

    state.dadosRelatorioTabelaQtdeAtendEstrela.forEach((d) => {
        estrelas.push(d.estrelas);
        porcentagens.push(d.porcentagem);
        confirmados.push(d.qtdeConfirmados + " Confirmados");
        if (state.filtroTpChamado) {
            bgColor = d.cor;
        }
    });

    const hoverValue = {
        id: 'hoverValue',
        afterDatasetsDraw(chart) {
            const { ctx, data, options } = chart;
            chart.getActiveElements().forEach((active) => {
                const value = `${data.datasets[active.datasetIndex].data[active.index]}★ - ${data.datasets[active.datasetIndex].porcentagem[active.index]}%`;
                const fontSize = options.hoverRadius;
                ctx.save();
                ctx.textAlign = 'center';
                ctx.font = `bold ${fontSize}px sans-serif`;
                ctx.lineDashOffset = 10;
                ctx.fillText(value, active.element.x, active.element.y);
                ctx.restore();
            });
        }
    };

    if (state.dadosRelatorioTabelaQtdeAtendEstrela.length > 0) {
        estrelas.push(5);
        estrelas.push(0);
        state.graficoQtdeAtendEstrela = new Chart(graficoQtdeAtendEstrela, {
            type: "bar",
            data: {
                labels: confirmados,
                datasets: [{
                    label: 'Pesquisa de Satisfação do Cliente',
                    data: estrelas,
                    porcentagem: porcentagens,
                    maxBarThickness: 75,
                    backgroundColor: [bgColor],
                    borderColor: ['rgb(255, 99, 132)'],
                    borderWidth: 1,
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                hoverRadius: 20,
                plugins: {
                    title: {
                        display: true,
                        text: 'Pesquisa de Satisfação do Cliente',
                        padding: {
                            top: 10,
                            bottom: 30
                        },
                        font: {
                            size: 20
                        }
                    }
                },
                onClick: async (e, active) => {
                    let numeroEstrelas;
                    let sql = "";
                    e.chart.data.datasets.forEach((d, index) => {
                        numeroEstrelas = d.data[active[index].index];
                        state.numeroEstrelas = d.data[active[index].index];
                    });

                    sql += `
                                    SELECT 
                                    C.AVALIACAOMOTIVO, C.DATA, T.DESCRICAO DESC_TIPO_CHAMADO, L.DESCRICAO DESC_LEITO, Q.DESCRICAO DESC_QUARTO 
                                    FROM CHAMADO C 
                                    JOIN TIPO_CHAMADO T ON T.ID = C.ID_TIPO_CHAMADO 
                                    JOIN LEITO L ON L.ID = C.ID_LEITO 
                                    JOIN QUARTO Q ON Q.ID = L.ID_QUARTO 
                                    WHERE 
                                    C.AVALIACAO = ${numeroEstrelas} 
                                    AND C.DATA BETWEEN '${retornaDataSql(auxDataInicial)}' and '${retornaDataSql(auxDataFinal)}' 
                                    ORDER BY C.DATA DESC`;

                    await api.listarSql(sql)
                        .then(resp => {
                            resp.forEach(r => {
                                state.dadoModalQtdeAtendEstrela.push({
                                    'motivo': r[0],
                                    'data': r[1],
                                    'chamadoDescricao': r[2],
                                    'leito': r[3],
                                    'quarto': r[4]
                                });
                            });
                        });
                    state.mostrarModalQtdeAtendEstrela = true;
                }
            },
            plugins: [hoverValue]
        });
    }
}

async function filtrarMotivos() {
    let sql = "";

    sql += `
                SELECT 
                C.AVALIACAOMOTIVO, C.DATA, T.DESCRICAO DESC_TIPO_CHAMADO, L.DESCRICAO DESC_LEITO, Q.DESCRICAO DESC_QUARTO 
                FROM CHAMADO C 
                JOIN TIPO_CHAMADO T ON T.ID = C.ID_TIPO_CHAMADO 
                JOIN LEITO L ON L.ID = C.ID_LEITO 
                JOIN QUARTO Q ON Q.ID = L.ID_QUARTO 
                WHERE 
                C.AVALIACAO = ${state.numeroEstrelas} 
                AND C.DATA BETWEEN '${retornaDataSql(state.valorFiltroDataInicial)}' and '${retornaDataSql(state.valorFiltroDataFinal)}' 
                `;

    switch (state.justificativa) {
        case "N":
            sql += `AND C.AVALIACAOMOTIVO IS NULL `;
            break;
        case "J":
            sql += `AND C.AVALIACAOMOTIVO IS NOT NULL `;
            break;
    }

    sql += ` ORDER BY C.DATA DESC`;

    state.dadoModalQtdeAtendEstrela = [];

    await api.listarSql(sql)
        .then(resp => {
            // console.log(sql);
            // console.log(resp);
            resp.forEach(r => {
                state.dadoModalQtdeAtendEstrela.push({
                    'motivo': r[0],
                    'data': r[1],
                    'chamadoDescricao': r[2],
                    'leito': r[3],
                    'quarto': r[4]
                });
            });
        });
}

function resetarMotivo() {
    state.dadoModalQtdeAtendEstrela = [];
}

//#endregion

//#region Atend Tempo

async function construirTabelaAtendTempo(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado) {
    state.valorFiltroSetor = pValorFiltroSetor;
    state.valorFiltroTPChamado = pValorFiltroTPChamado;
    let sql = `SELECT
                       S.DESCRICAO, C.DATA, count(*)
                       FROM CHAMADO C
                       JOIN TIPO_CHAMADO T ON T.ID = C.ID_TIPO_CHAMADO
                       JOIN LEITO L ON L.ID = C.ID_LEITO 
                       JOIN QUARTO Q ON Q.ID = L.ID_QUARTO 
                       JOIN SETOR S ON S.ID = Q.ID_SETOR 
					   `;
    if (retornaData(pDataInicial) > retornaData(pDataFinal)) {
        state.titulo = "Aviso";
        state.textoErro = "A Data Inicial não pode ser maior que a Data Final";
        state.existeErro = true;
    } else {
        let auxDataInicial = moment(pDataInicial).format("DD.MM.YYYY");
        let auxDataFinal = moment(pDataFinal).format("DD.MM.YYYY");
        sql += `WHERE  `;

        if (Number(pValorFiltroSetor) != 0) {
            sql += `S.ID = ${pValorFiltroSetor} AND `;
        }

        if (Number(pValorFiltroTPChamado) != 0) {
            sql += `T.ID = ${pValorFiltroTPChamado} AND `;
        }

        // if (pValorFiltroPosicao.trim() != "") {
        //     sql += ` (C.POSICAO = '${pValorFiltroPosicao}'`;
        //     if (pValorFiltroPosicaoAuxiliar.trim() != "") {
        //         sql += ` OR C.POSICAO = '${pValorFiltroPosicaoAuxiliar}'`;
        //     }
        //     sql += `) AND `;
        // }
        if (pUsarPosicaoAberto == true || pUsarPosicaoAdministrativo == true || pUsarPosicaoFechado == true || pUsarPosicaoCancelado == true)
            sql += `(`;
        if (pUsarPosicaoAberto) {
            sql += `C.POSICAO = 'AB'`;
            if (pUsarPosicaoAdministrativo == true || pUsarPosicaoFechado == true || pUsarPosicaoCancelado == true)
                sql += ` OR `;
            else
                sql += `) AND `;
        }

        if (pUsarPosicaoAdministrativo) {
            sql += `C.POSICAO = 'AD'`;
            if (pUsarPosicaoFechado == true || pUsarPosicaoCancelado == true)
                sql += ` OR `;
            else
                sql += `) AND `;
        }

        if (pUsarPosicaoFechado) {
            sql += `C.POSICAO = 'FE'`;
            if (pUsarPosicaoCancelado == true)
                sql += ` OR `;
            else
                sql += `) AND `;
        }

        if (pUsarPosicaoCancelado) {
            sql += `C.POSICAO = 'CA') AND `;
        }

        sql += `
                        C.DATA BETWEEN '${auxDataInicial}' AND '${auxDataFinal}' `;
        sql += retornaSqlDuracao(pValorDuracao);

        sql += ` GROUP BY 1,2`;

        await api.listarSql(sql).then((resp) => {
            state.dadosRelatorioTabelaAtendTempo = [];
            state.dadosRelatorioTabelaOrdenadoAtendTempo = [];
            resp.forEach((r) => {
                state.dadosRelatorioTabelaAtendTempo.push({ data: r[0], qtdeAtend: r[1] });
                state.dadosRelatorioTabelaOrdenadoAtendTempo.unshift({
                    setor: r[0],
                    data: r[1],
                    qtdeAtend: r[2],
                });
            });
        });
    }
}

async function construirGraficoAtendTempo() {
    const graficoRelatorioAtendTempo = document.getElementById("graficoRelatorioAtendTempo").getContext("2d");
    if (state.graficoAtendTempo) {
        state.graficoAtendTempo.destroy();
    }

    const hoverValue = {
        id: "hoverValue",
        afterDatasetsDraw(chart) {
            const { ctx, data, options } = chart;
            chart.getActiveElements().forEach((active) => {
                const value = data.datasets[active.datasetIndex].data[active.index];
                const fontSize = options.hoverRadius;
                ctx.save();
                ctx.textAlign = "center";
                ctx.font = `bold ${fontSize}px sans-serif`;
                ctx.lineDashOffset = 10;
                ctx.fillText(value, active.element.x, active.element.y);
                ctx.restore();
            });
        },
    };

    let dia = [];
    let qtdeAtend = [];
    state.dataUSA = [];

    state.dadosRelatorioTabelaAtendTempo.forEach((d) => {
        dia.push(retornaDataFormatada(d.data));
        state.dataUSA.push(retornaDataFormatadaUSA(d.data));
        qtdeAtend.push(d.qtdeAtend);
    });

    if (state.dadosRelatorioTabelaAtendTempo.length > 0) {
        state.graficoAtendTempo = new Chart(graficoRelatorioAtendTempo, {
            type: "line",
            data: {
                labels: dia,
                datasets: [
                    {
                        label: qtdeAtend, //
                        data: qtdeAtend, // Valor do tempo médio
                        backgroundColor: ["rgb(255, 255, 255)"],
                        borderColor: ["rgb(55, 255, 55)"],
                    },
                ],
            },
            options: {
                responsive: true, // Permite que o gráfico seja responsivo
                maintainAspectRatio: false, // Desativa a proporção de aspecto
                hoverRadius: 20,
                plugins: {
                    title: {
                        display: true,
                        text: "Atendimento ao Longo do Tempo",
                        padding: {
                            top: 10,
                            bottom: 30,
                        },
                        font: {
                            size: 20,
                        },
                    },
                },
                onClick: async (e, active) => {
                    let data = `'${state.dataUSA[active[0].index]}' and '${state.dataUSA[active[0].index]}'`;
                    await api.filtrarDados("", state.valorFiltroTPChamado, state.valorFiltroSetor, 0, 0, "desc", "desc", data)
                        .then((resposta) => {
                            let aux = [];
                            aux = resposta;
                            for (let i = 0; i < aux.length; i++) {
                                for (let j = 0; j < aux.length - i - 1; j++) {
                                    if (aux[j].id < aux[j + 1].id) {
                                        let temp = aux[j];
                                        aux[j] = aux[j + 1];
                                        aux[j + 1] = temp;
                                    }
                                }
                            }
                            state.dadoModalAtendTempo = aux;
                        });
                    state.mostrarModalAtendTempo = true;
                },
            },
            plugins: [hoverValue],
        });
    }
}

//#endregion

async function filtrar(aux, pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pVisualizacao, pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado) {
    state.tabela = pVisualizacao;
    state.valorFiltroSetor = pValorFiltroSetor;
    state.valorFiltroTPChamado = pValorFiltroTPChamado;
    state.valorFiltroQuarto = 0;
    state.valorFiltroLeito = 0;
    state.usarPosicaoAberto = pUsarPosicaoAberto;
    state.usarPosicaoAdministrativo = pUsarPosicaoAdministrativo;
    state.usarPosicaoFechado = pUsarPosicaoFechado;
    state.usarPosicaoCancelado = pUsarPosicaoCancelado;
    state.valorOrderData = "desc";
    state.valorOrderHora = "desc";
    state.valorFiltroDataInicial = pDataInicial;
    state.valorFiltroDataFinal = pDataFinal;
    state.dadosHora = [];
    state.atualizandoDados = true;
    state.msgAtualizandoDados = "Buscando dados. Por favor, aguarde";
    if (state.historicoGeral == false) {
        (pVisualizacao == "Card") ? state.tabela = 'Grafico' : "";
        state.relatorioGerado = true;
        await construirTabelas(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado);
        await montarObjetoGrafico(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pValorDuracao);
        (state.tabela == 'Grafico') ? construirGraficos(pDataInicial, pDataFinal) : "";
    }

    if (state.historicoGeral == true) {
        (pVisualizacao == 'Grafico') ? state.card = "Card" : state.card = pVisualizacao;
        await carregarChamados(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, state.card, pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado);
    }
    state.atualizandoDados = false;
}

async function construirTabelas(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado) {
    await construirTabelaTempoMedio(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado); // falta
    await construirTabelaAtendEstrela(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado);
    await construirTabelaMediaAvaliacaoSetor(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado);
    await construirTabelaAtendTempo(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado);
}

async function construirGraficos(pDataInicial, pDataFinal, pValorDuracao) {
    await construirGraficoBarraTempoMedio();
    await construirGraficoAtendEstrela(pDataInicial, pDataFinal);
    await construirGraficoMediaAvaliacaoSetor();
    await construirGraficoAtendTempo();
}

function retornaDataFormatada(pData) {
    return moment(pData).format("DD/MM/YYYY");
}

function retornaDataFormatadaUSA(pData) {
    return moment(pData).format("MM/DD/YYYY");
}

function retornaData(pData) {
    return new Date(pData);
}

function retornaDataSql(pData) {
    return moment(pData).format("DD.MM.YYYY");
}

function desativarModal() {
    state.existeErro = false;
}

function fecharModal() {
    state.dadoModalTempoMedio = Array();
    state.mostrarModalTempoMedio = Boolean();
    state.dadoModalQtdeAtendEstrela = Array();
    state.mostrarModalQtdeAtendEstrela = Boolean();
    state.dadoModalAtendTempo = Array();
    state.mostrarModalAtendTempo = Boolean();
    state.dadoModalMediaAvaliacaoSetor = Array();
}

function calcularDiferencaDeTempo(dataInicio, dataFim) {
    const MILISEGUNDOS_POR_DIA = 24 * 60 * 60 * 1000;

    const inicio = new Date(dataInicio);
    const fim = new Date(dataFim);

    // Tratamento caso as datas estejam no mesmo dia
    if (inicio.toDateString() === fim.toDateString()) {
        return fim - inicio;
    }

    const inicioDaProximaData = new Date(inicio);
    inicioDaProximaData.setHours(0, 0, 0, 0);
    inicioDaProximaData.setDate(inicioDaProximaData.getDate() + 1);

    const tempoAteFimDoDia = inicioDaProximaData - inicio;

    const diasIntervenientes = Math.floor((fim - inicioDaProximaData) / MILISEGUNDOS_POR_DIA);

    const tempoAteInicioDoDia = (fim - inicioDaProximaData) % MILISEGUNDOS_POR_DIA;

    const tempoTotal = tempoAteFimDoDia + diasIntervenientes * MILISEGUNDOS_POR_DIA + tempoAteInicioDoDia;

    return tempoTotal;
}

async function carregarChamados(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pValorVisualizacao = 'Tabela', pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado) { //falta

    (pValorFiltroSetor) ? state.valorFiltroSetor = pValorFiltroSetor : "";
    (pValorFiltroTPChamado) ? state.valorFiltroTPChamado = pValorFiltroTPChamado : "";
    (pDataInicial) ? state.valorFiltroDataInicial = pDataInicial : "";
    (pDataFinal) ? state.valorFiltroDataFinal = pDataFinal : "";
    (pValorDuracao) ? state.valorFiltroDuracao = pValorDuracao : "";
    (pUsarPosicaoAberto) ? state.usarPosicaoAberto = pUsarPosicaoAberto : "";
    (pUsarPosicaoAdministrativo) ? state.usarPosicaoAdministrativo = pUsarPosicaoAdministrativo : "";
    (pUsarPosicaoFechado) ? state.usarPosicaoFechado = pUsarPosicaoFechado : "";
    (pUsarPosicaoCancelado) ? state.usarPosicaoCancelado = pUsarPosicaoCancelado : "";
    (pValorVisualizacao) ? state.card = pValorVisualizacao : "";

    let pData;
    if (state.valorFiltroDataInicial != null && state.valorFiltroDataFinal != null) {
        let pDataTemp1 = moment(state.valorFiltroDataInicial).format("MM/DD/YYYY");
        let pDataTemp2 = moment(state.valorFiltroDataFinal).format("MM/DD/YYYY");
        pData = "'" + pDataTemp1 + "' and '" + pDataTemp2 + "'";
    }

    await api.filtrarDados(state.valorFiltroPosicao, state.valorFiltroTPChamado, state.valorFiltroSetor,
        state.valorFiltroQuarto, state.valorFiltroLeito, state.usarPosicaoAberto, state.usarPosicaoAdministrativo,
        state.usarPosicaoFechado, state.usarPosicaoCancelado, state.valorOrderData, state.valorOrderHora, pData)
        .then(resposta => {//Bubble Sort
            let aux = [];
            aux = resposta;
            for (let i = 0; i < aux.length; i++) {
                for (let j = 0; j < (aux.length - i - 1); j++) {
                    if (aux[j].id < aux[j + 1].id) {
                        let temp = aux[j];
                        aux[j] = aux[j + 1];
                        aux[j + 1] = temp;
                    }
                }
            }
            if (state.valorFiltroDuracao != "0") {
                aux = aux.filter((a) => {
                    var timeParts = a.hora.split(":");
                    var dataInicial = new Date(new Date(a.data).getFullYear(), new Date(a.data).getMonth(), new Date(a.data).getDate(),
                        parseInt(timeParts[0], 10), parseInt(timeParts[1], 10), parseInt(timeParts[2], 10));
                    var dataFinal, horaFinal;

                    if (a.dtFinalizacao) {
                        horaFinal = a.hrFinalizacao.split(":");
                        dataFinal = new Date(new Date(a.dtFinalizacao).getFullYear(), new Date(a.dtFinalizacao).getMonth(), new Date(a.dtFinalizacao).getDate(),
                            parseInt(horaFinal[0], 10), parseInt(horaFinal[1], 10), parseInt(horaFinal[2], 10));
                    }

                    if (a.dtCancelamento) {
                        horaFinal = a.hrCancelamento.split(":");
                        dataFinal = new Date(new Date(a.dtCancelamento).getFullYear(), new Date(a.dtCancelamento).getMonth(), new Date(a.dtCancelamento).getDate(),
                            parseInt(horaFinal[0], 10), parseInt(horaFinal[1], 10), parseInt(horaFinal[2], 10))
                    }
                    let numAntes = "", numDepois = "";
                    let dataCalculada = (dataFinal - dataInicial) / 1000;
                    if (state.valorFiltroDuracao == "1") {
                        return dataCalculada > 7200;
                    } else if (state.valorFiltroDuracao != "0") {
                        for (let i = 0; i < state.valorFiltroDuracao.length; i++) {
                            if (i < state.valorFiltroDuracao.indexOf("a")) {
                                numAntes += state.valorFiltroDuracao[i]
                            }
                            if (i > state.valorFiltroDuracao.indexOf("d")) {
                                numDepois += state.valorFiltroDuracao[i]
                            }
                        }
                        return dataCalculada > numAntes && dataCalculada < numDepois;
                    }
                });
            }
            state.chamados = aux;
        });
}

async function alterarVisualizacaoHistorico(pHistorico, aux, pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pVisualizacao, pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado) {
    state.historicoGeral = pHistorico;
    if (state.graficoAtendTempo) {
        state.graficoAtendTempo.destroy();
    }
    if (state.graficoTempoMedioBarras) {
        state.graficoTempoMedioBarras.destroy();
    }
    if (state.graficoMediaAvaliacaoSetorBarra) {
        state.graficoMediaAvaliacaoSetorBarra.destroy();
    }
    if (state.graficoQtdeAtendEstrela) {
        state.graficoQtdeAtendEstrela.destroy();
    }
    if (pHistorico == false) {
        await filtrar(aux, pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pVisualizacao, pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado);
    }
    if (pHistorico == true) {
        await carregarChamados(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal, pVisualizacao, pValorDuracao, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado);
    }
}

function retornaSqlDuracao(pValorDuracao, hql = false) {
    let sqlDuracao = "";
    let inteiro = (hql) ? "int" : "INTEGER";
    if (String(pValorDuracao).trim() == "1") {
        sqlDuracao += ` 
    AND   
    ( 
        (COALESCE(CAST(c.HrFinalizacao - c.Hora AS ${inteiro}),0) %2B (COALESCE(CAST(c.DtFinalizacao - c.Data AS ${inteiro}),0) * 86400)) >= 7200 
            OR 
        (COALESCE(CAST(c.HrCancelamento - c.Hora AS ${inteiro}),0) %2B (COALESCE(CAST(c.DtCancelamento - c.Data AS ${inteiro}),0) * 86400)) >= 7200 
    ) 
`;      // %2B é a versão codificada para urls do sinal '+'
    } else if (String(pValorDuracao).trim() != "0" && String(pValorDuracao).trim() != "1" && String(pValorDuracao).trim() != "") {
        sqlDuracao += ` 
    AND  
    ( 
        (COALESCE(CAST(c.HrFinalizacao - c.Hora AS ${inteiro}),0) %2B (COALESCE(CAST(c.DtFinalizacao - c.Data AS ${inteiro}),0) * 86400)) BETWEEN ${pValorDuracao} 
            OR 
        (COALESCE(CAST(c.HrCancelamento - c.Hora AS ${inteiro}),0) %2B (COALESCE(CAST(c.DtCancelamento - c.Data AS ${inteiro}),0) * 86400)) BETWEEN ${pValorDuracao} 
    ) 
`;
    }
    return sqlDuracao;
}

//#endregion

//#region Exportação PDF

const contentToExportGridHistoricoGeral = ref(null);
const contentToExportCardHistoricoGeral = ref(null);
const contentToExportTempoMedio = ref(null);
const contentToExportQtdeAtendEstrela = ref(null);
const contentToExportOrdenadoAtendTempo = ref(null);
const contentToExportMediaAvaliacaoSetor = ref(null);

async function exportToPDF(metodo, tirarRelatorios) {
    // console.log(tirarRelatorios);
    if (metodo == "PDF") {
        const margin = 15;
        const tablePadding = 1;
        let currentPage = 1;

        const addTableCellWithLineBreak = (text, x, y, width, pdf) => {
            const lines = pdf.splitTextToSize(text, width - 4);
            pdf.rect(x, y, width, 20); // Ajuste a altura conforme necessário
            pdf.text(lines, x + 2, y + 8);
        };

        const addTableCellWithLineBreakComCor = (text, x, y, width, bgColor, pdf) => {
            const lines = pdf.splitTextToSize(text, width - 4);
            pdf.setFillColor(bgColor.r, bgColor.g, bgColor.b);
            pdf.rect(x, y, width, 20, 'F'); // Ajuste a altura conforme necessário
            pdf.text(lines, x + 2, y + 8);
        };

        if (tirarRelatorios.historicoGeral && state.card === 'Tabela') {
            const contentElement = contentToExportGridHistoricoGeral.value;
            const pdf = new jsPDF();
            // const margin = 15;
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight() - margin * 2;
            // const tablePadding = 1;
            let yPos = margin + tablePadding;
            // let currentPage = 1;
            pdf.setFontSize(9);

            contentElement.querySelectorAll('table thead tr').forEach((row) => {
                const paragraphHeight = 10; // Defina a altura estimada do parágrafo
                const spaceLeftOnPage = pageHeight - yPos - margin;
                const cells = row.querySelectorAll('th.d-print-grid');
                const cellWidth = (pageWidth - 2 * margin - 2 * tablePadding) / cells.length; // Subtrair margens e espaçamento

                cells.forEach((cell, index) => {
                    if (!cell.classList.contains('d-print-none')) {
                        const cellText = cell.innerText;
                        const xPos = margin + tablePadding + index * cellWidth; // Adicionar margem e espaçamento
                        addTableCellWithLineBreak(cellText, xPos, yPos, cellWidth, pdf);
                    }
                });

                yPos += 10; // Altura da célula

                if (spaceLeftOnPage < paragraphHeight) {
                    pdf.addPage();
                    currentPage++;
                    yPos = margin;
                }

                yPos += paragraphHeight;
            });

            contentElement.querySelectorAll('table tbody tr').forEach((row) => {
                const paragraphHeight = 10; // Defina a altura estimada do parágrafo
                const spaceLeftOnPage = pageHeight - yPos - margin;
                const cells = row.querySelectorAll('td.d-print-grid');
                const cellWidth = (pageWidth - 2 * margin - 2 * tablePadding) / cells.length; // Subtrair margens e espaçamento
                let cor = row.style.backgroundColor;

                cells.forEach((cell, index) => {
                    if (!cell.classList.contains('d-print-none')) {
                        const cellText = cell.innerText;
                        const xPos = margin + tablePadding + index * cellWidth; // Adicionar margem e espaçamento
                        addTableCellWithLineBreakComCor(cellText, xPos, yPos, cellWidth, retornaObjetoCor(cor), pdf);
                    }
                });

                yPos += 10; // Altura da célula

                if (spaceLeftOnPage < paragraphHeight) {
                    pdf.addPage();
                    currentPage++;
                    yPos = margin;
                }

                yPos += paragraphHeight;
            });

            // Exibir o número total de páginas no rodapé
            for (let i = 1; i <= currentPage; i++) {
                pdf.setPage(i);
                pdf.text(`${i} / ${currentPage}`, pageWidth - margin, pageHeight + margin, { align: 'right' });
            }
            pdf.save(`${moment().format()}.pdf`);
        }

        if (tirarRelatorios.historicoGeral && state.card === 'Card') {
            const contentElement = contentToExportCardHistoricoGeral.value;
            const pdf = new jsPDF();
            // const margin = 15;
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight() - margin * 2;
            // const tablePadding = 1;
            let yPos = margin + tablePadding;
            // let currentPage = 1;
            pdf.setFontSize(9);
            function createCard(pdf, x, y, width, height, row) {
                let tempo, posicao;

                (row.querySelector('#administrativo')?.textContent) ? (tempo = row.querySelector('#administrativo')?.textContent, posicao = "Administrativo") : "";
                (row.querySelector('#tempoFinalizado')?.textContent) ? (tempo = row.querySelector('#tempoFinalizado')?.textContent, posicao = "Finalizado") : "";
                (row.querySelector('#tempoCancelado')?.textContent) ? (tempo = row.querySelector('#tempoCancelado')?.textContent, posicao = "Cancelado") : "";
                // (row.querySelector('#tempoCronometro')?.textContent) ? (tempo = row.querySelector('#tempoCronometro')?.textContent, posicao = "Aberto") : "";

                pdf.rect(x, y, width, height);
                pdf.text(String(row.querySelector('#spnDesc')?.textContent), x + 5, y + 5);
                pdf.text(String(row.querySelector('#leitoDesc')?.textContent), x + 5, y + 15);
                pdf.text(String(row.querySelector('#quartoDesc')?.textContent), x + 5, y + 25);
                pdf.text(String(row.querySelector('#horaInicio')?.textContent), x + 5, y + 35);
                pdf.text(posicao, x + 5, y + 45);
                pdf.text(tempo, x + 5, y + 55);
            }

            let x = 10, y = 10, width = 50, height = 60;

            contentElement.querySelectorAll('div.card').forEach((card, index) => {
                const paragraphHeight = 10; // Defina a altura estimada do parágrafo
                const spaceLeftOnPage = pageHeight - yPos - margin;

                createCard(pdf, x, y, width, height, card);

                if (index % 3 == 0 && index != 0) {
                    y += 70;
                    x = 10;
                } else {
                    x += 70;
                }

                yPos += 10; // Altura da célula

                if ((spaceLeftOnPage < paragraphHeight) && (contentElement.querySelectorAll('div.card').length - 1 != index)) {
                    pdf.addPage();
                    currentPage++;
                    yPos = margin;
                    x = 10, y = 10, width = 50, height = 60;
                }

                yPos += paragraphHeight;
            });

            // Exibir o número total de páginas no rodapé
            for (let i = 1; i <= currentPage; i++) {
                pdf.setPage(i);
                pdf.text(`${i} / ${currentPage}`, pageWidth - margin, pageHeight + margin + 5, { align: 'right' });
            }

            pdf.save(`${moment().format()}.pdf`);
        }

        // if (state.tabela == 'Tabela') {
        if (tirarRelatorios.tempoSetor) {
            const contentElement = contentToExportTempoMedio.value;
            const pdf = new jsPDF();
            // const margin = 15;
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight() - margin * 2;
            // const tablePadding = 1;
            let yPos = margin + tablePadding;
            // let currentPage = 1;
            pdf.setFontSize(9);

            contentElement.querySelectorAll('table thead tr').forEach((row) => {
                const paragraphHeight = 10; // Defina a altura estimada do parágrafo
                const spaceLeftOnPage = pageHeight - yPos - margin;
                const cells = row.querySelectorAll('th');
                const cellWidth = (pageWidth - 2 * margin - 2 * tablePadding) / cells.length; // Subtrair margens e espaçamento

                cells.forEach((cell, index) => {
                    if (!cell.classList.contains('d-print-none')) {
                        const cellText = cell.innerText;
                        const xPos = margin + tablePadding + index * cellWidth; // Adicionar margem e espaçamento
                        addTableCellWithLineBreak(cellText, xPos, yPos, cellWidth, pdf);
                    }
                });

                yPos += 10; // Altura da célula

                if (spaceLeftOnPage < paragraphHeight) {
                    pdf.addPage();
                    currentPage++;
                    yPos = margin;
                }

                yPos += paragraphHeight;
            });
            contentElement.querySelectorAll('table tbody tr').forEach((row) => {
                const paragraphHeight = 10; // Defina a altura estimada do parágrafo
                const spaceLeftOnPage = pageHeight - yPos - margin;
                const cells = row.querySelectorAll('td');
                const cellWidth = (pageWidth - 2 * margin - 2 * tablePadding) / cells.length; // Subtrair margens e espaçamento

                cells.forEach((cell, index) => {
                    if (!cell.classList.contains('d-print-none')) {
                        const cellText = cell.innerText;
                        const xPos = margin + tablePadding + index * cellWidth; // Adicionar margem e espaçamento
                        addTableCellWithLineBreak(cellText, xPos, yPos, cellWidth, pdf);
                    }

                });

                yPos += 10; // Altura da célula

                if (spaceLeftOnPage < paragraphHeight) {
                    pdf.addPage();
                    currentPage++;
                    yPos = margin;
                }

                yPos += paragraphHeight;
            });

            for (let i = 1; i <= currentPage; i++) {
                pdf.setPage(i);
                pdf.text(`${i} / ${currentPage}`, pageWidth - margin, pageHeight + margin, { align: 'right' });
            }
            pdf.save(`Tempo de Atendimento por Setor.pdf`);
        }

        if (tirarRelatorios.atendimentoTempo) {
            const contentElement = contentToExportOrdenadoAtendTempo.value;
            const pdf = new jsPDF();
            // const margin = 15;
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight() - margin * 2;
            // const tablePadding = 1;
            let yPos = margin + tablePadding;
            // let currentPage = 1;
            pdf.setFontSize(9);

            contentElement.querySelectorAll('table thead tr').forEach((row) => {
                const paragraphHeight = 10; // Defina a altura estimada do parágrafo
                const spaceLeftOnPage = pageHeight - yPos - margin;
                const cells = row.querySelectorAll('th');
                const cellWidth = (pageWidth - 2 * margin - 2 * tablePadding) / cells.length; // Subtrair margens e espaçamento

                cells.forEach((cell, index) => {
                    if (!cell.classList.contains('d-print-none')) {
                        const cellText = cell.innerText;
                        const xPos = margin + tablePadding + index * cellWidth; // Adicionar margem e espaçamento
                        addTableCellWithLineBreak(cellText, xPos, yPos, cellWidth, pdf);
                    }
                });

                yPos += 10; // Altura da célula

                if (spaceLeftOnPage < paragraphHeight) {
                    pdf.addPage();
                    currentPage++;
                    yPos = margin;
                }

                yPos += paragraphHeight;
            });
            contentElement.querySelectorAll('table tbody tr').forEach((row) => {
                const paragraphHeight = 10; // Defina a altura estimada do parágrafo
                const spaceLeftOnPage = pageHeight - yPos - margin;
                const cells = row.querySelectorAll('td');
                const cellWidth = (pageWidth - 2 * margin - 2 * tablePadding) / cells.length; // Subtrair margens e espaçamento
                let cor = row.style.backgroundColor;

                cells.forEach((cell, index) => {
                    if (!cell.classList.contains('d-print-none')) {
                        const cellText = cell.innerText;
                        const xPos = margin + tablePadding + index * cellWidth; // Adicionar margem e espaçamento
                        addTableCellWithLineBreak(cellText, xPos, yPos, cellWidth, pdf);
                    }
                });

                yPos += 10; // Altura da célula

                if (spaceLeftOnPage < paragraphHeight) {
                    pdf.addPage();
                    currentPage++;
                    yPos = margin;
                }

                yPos += paragraphHeight;
            });

            for (let i = 1; i <= currentPage; i++) {
                pdf.setPage(i);
                pdf.text(`${i} / ${currentPage}`, pageWidth - margin, pageHeight + margin, { align: 'right' });
            }
            pdf.save(`Atendimento ao Longo do Tempo.pdf`);
        }

        if (tirarRelatorios.mediaEstrelasSetor) {
            const contentElement = contentToExportMediaAvaliacaoSetor.value;
            const pdf = new jsPDF();
            // const margin = 15;
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight() - margin * 2;
            // const tablePadding = 1;
            let yPos = margin + tablePadding;
            // let currentPage = 1;
            pdf.setFontSize(9);

            contentElement.querySelectorAll('table thead tr').forEach((row) => {
                const paragraphHeight = 10; // Defina a altura estimada do parágrafo
                const spaceLeftOnPage = pageHeight - yPos - margin;
                const cells = row.querySelectorAll('th');
                const cellWidth = (pageWidth - 2 * margin - 2 * tablePadding) / cells.length; // Subtrair margens e espaçamento

                cells.forEach((cell, index) => {
                    if (!cell.classList.contains('d-print-none')) {
                        const cellText = cell.innerText;
                        const xPos = margin + tablePadding + index * cellWidth; // Adicionar margem e espaçamento
                        addTableCellWithLineBreak(cellText, xPos, yPos, cellWidth, pdf);
                    }
                });

                yPos += 10; // Altura da célula

                if (spaceLeftOnPage < paragraphHeight) {
                    pdf.addPage();
                    currentPage++;
                    yPos = margin;
                }

                yPos += paragraphHeight;
            });
            contentElement.querySelectorAll('table tbody tr').forEach((row) => {
                const paragraphHeight = 10; // Defina a altura estimada do parágrafo
                const spaceLeftOnPage = pageHeight - yPos - margin;
                const cells = row.querySelectorAll('td');
                const cellWidth = (pageWidth - 2 * margin - 2 * tablePadding) / cells.length; // Subtrair margens e espaçamento
                let cor = row.style.backgroundColor;

                cells.forEach((cell, index) => {
                    if (!cell.classList.contains('d-print-none')) {
                        const cellText = cell.innerText;
                        const xPos = margin + tablePadding + index * cellWidth; // Adicionar margem e espaçamento
                        addTableCellWithLineBreak(cellText, xPos, yPos, cellWidth, pdf);
                    }
                });

                yPos += 10; // Altura da célula

                if (spaceLeftOnPage < paragraphHeight) {
                    pdf.addPage();
                    currentPage++;
                    yPos = margin;
                }

                yPos += paragraphHeight;
            });

            for (let i = 1; i <= currentPage; i++) {
                pdf.setPage(i);
                pdf.text(`${i} / ${currentPage}`, pageWidth - margin, pageHeight + margin, { align: 'right' });
            }
            pdf.save(`Avaliação do Cliente por Setor.pdf`);
        }

        if (tirarRelatorios.satisfacaoCliente) {
            const contentElement = contentToExportQtdeAtendEstrela.value;
            const pdf = new jsPDF();
            // const margin = 15;
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight() - margin * 2;
            // const tablePadding = 1;
            let yPos = margin + tablePadding;
            // let currentPage = 1;
            pdf.setFontSize(9);

            contentElement.querySelectorAll('table thead tr').forEach((row) => {
                const paragraphHeight = 10; // Defina a altura estimada do parágrafo
                const spaceLeftOnPage = pageHeight - yPos - margin;
                const cells = row.querySelectorAll('th');
                const cellWidth = (pageWidth - 2 * margin - 2 * tablePadding) / cells.length; // Subtrair margens e espaçamento

                cells.forEach((cell, index) => {
                    if (!cell.classList.contains('d-print-none')) {
                        const cellText = cell.innerText;
                        const xPos = margin + tablePadding + index * cellWidth; // Adicionar margem e espaçamento
                        addTableCellWithLineBreak(cellText, xPos, yPos, cellWidth, pdf);
                    }
                });

                yPos += 10; // Altura da célula

                if (spaceLeftOnPage < paragraphHeight) {
                    pdf.addPage();
                    currentPage++;
                    yPos = margin;
                }

                yPos += paragraphHeight;
            });
            contentElement.querySelectorAll('table tbody tr').forEach((row) => {
                const paragraphHeight = 10; // Defina a altura estimada do parágrafo
                const spaceLeftOnPage = pageHeight - yPos - margin;
                const cells = row.querySelectorAll('td');
                const cellWidth = (pageWidth - 2 * margin - 2 * tablePadding) / cells.length; // Subtrair margens e espaçamento
                let cor = row.style.backgroundColor;

                cells.forEach((cell, index) => {
                    if (!cell.classList.contains('d-print-none')) {
                        const cellText = cell.innerText;
                        let texto = "";
                        const xPos = margin + tablePadding + index * cellWidth; // Adicionar margem e espaçamento
                        (cell.innerText.includes('1 stars')) ? texto = "Avaliação 1 Estrela" : texto = cell.innerText;
                        (cell.innerText.includes('2 stars')) ? texto = "Avaliação 2 Estrelas" : texto = cell.innerText;
                        (cell.innerText.includes('3 stars')) ? texto = "Avaliação 3 Estrelas" : texto = cell.innerText;
                        (cell.innerText.includes('4 stars')) ? texto = "Avaliação 4 Estrelas" : texto = cell.innerText;
                        (cell.innerText.includes('5 stars')) ? texto = "Avaliação 5 Estrelas" : texto = cell.innerText;

                        addTableCellWithLineBreak(texto, xPos, yPos, cellWidth, pdf);
                    }
                });

                yPos += 10; // Altura da célula

                if (spaceLeftOnPage < paragraphHeight) {
                    pdf.addPage();
                    currentPage++;
                    yPos = margin;
                }

                yPos += paragraphHeight;
            });

            for (let i = 1; i <= currentPage; i++) {
                pdf.setPage(i);
                pdf.text(`${i} / ${currentPage}`, pageWidth - margin, pageHeight + margin, { align: 'right' });
            }
            pdf.save(`Satisfação do Cliente.pdf`);
        }
        // }
    };
}

function retornaObjetoCor(pCor) {
    let objCor = {
        r: Number(),
        g: Number(),
        b: Number()
    };
    let r = "", g = "", b = "";

    for (let i = pCor.indexOf("(") + 1; i < pCor.indexOf(","); i++)
        r += String(pCor[i]);
    objCor.r = Number(r);

    for (let i = pCor.indexOf(",") + 1; i < pCor.lastIndexOf(","); i++)
        g += String(pCor[i]);
    objCor.g = Number(g);

    for (let i = pCor.lastIndexOf(",") + 1; i < pCor.indexOf(")"); i++)
        b += String(pCor[i]);
    objCor.b = Number(b);

    if (objCor.r == 18, objCor.g == 203, objCor.b == 40) {
        objCor.r = 160;
        objCor.g = 234;
        objCor.b = 169;
    }
    if (objCor.r == 239, objCor.g == 228, objCor.b == 70) {
        objCor.r = 248;
        objCor.g = 244;
        objCor.b = 181;
    }
    if (objCor.r == 234, objCor.g == 37, objCor.b == 60) {
        objCor.r = 246;
        objCor.g = 168;
        objCor.b = 177;
    }

    // objCor.a = 0;
    // console.log(objCor);
    return objCor;
}

//#endregion

async function resetarTela() {
    state.dadosRelatorioTabelaTempoMedio = Array();
    state.dadoModalTempoMedio = Array();
    state.dadosRelatorioTabelaQtdeAtendEstrela = Array();
    state.dadoModalQtdeAtendEstrela = Array();
    state.dadosRelatorioTabelaAtendTempo = Array();
    state.dadosRelatorioTabelaOrdenadoAtendTempo = Array();
    state.dadoModalAtendTempo = Array();
    state.dadosRelatorioTabelaMediaAvaliacaoSetor = Array();
    state.dadoModalMediaAvaliacaoSetor = Array();
    if (state.graficoAtendTempo) {
        state.graficoAtendTempo.destroy();
    }
    if (state.graficoQtdeAtendEstrela) {
        state.graficoQtdeAtendEstrela.destroy();
    }
    if (state.graficoMediaAvaliacaoSetorBarra) {
        state.graficoMediaAvaliacaoSetorBarra.destroy();
    }
    if (state.graficoTempoMedioBarras) {
        state.graficoTempoMedioBarras.destroy();
    }
}

onMounted(async () => {
    Chart.register(LinearScale, LineController, CategoryScale, BarElement, BarController, Title, PieController, ArcElement, DoughnutController, LineElement, PointElement);
    // state.atualizandoDados = true;
    state.msgAtualizandoDados = "Buscando dados. Por favor, aguarde";
    setTimeout(async () => {
        await api.listarTipoChamado().then(resp => {
            resp.forEach((t) => {
                state.lstTpChamadoDesc.push(t.descricao);
                state.lstTpChamado.push(t);
            });
        });
        await api.listarSetor().then(resp => {
            resp.forEach((e) => {
                state.lstSetorDesc.push(e.descricao);
                state.lstSetor.push(e);
            });
        });
        // tipoChamado.value.forEach((t) => {
        //     state.lstTpChamadoDesc.push(t.descricao);
        // });
        // setores.value.forEach((e) => {
        //     state.lstSetorDesc.push(e.descricao);
        // });
        // let diaInicio = props.formatarDataInicioMes(new Date());
        // await construirTabelas(state.valorFiltroSetor, state.valorFiltroTPChamado, state.valorFiltroPosicao, diaInicio, new Date(), state.tabela, "");
        // await montarObjetoGrafico(state.valorFiltroSetor, state.valorFiltroTPChamado, diaInicio, new Date(), "0");
        // await construirGraficos(diaInicio, new Date());
        // await carregarChamados(state.valorFiltroSetor, state.valorFiltroTPChamado, state.valorFiltroPosicao, diaInicio, new Date(), "Card", "0")
        // state.atualizandoDados = false;
    }, 1500);
});

// const tipoChamado = computed(async () => {
//     return store.state.tipoChamado;
// });

// const setores = computed(() => {
//     return store.state.setores;
// });
</script>

<style scoped>
.cursor-default {
    cursor: pointer;
}

p {
    margin-bottom: 0;
    margin-top: 7px;
}

.displayflex {
    display: flex;
}

.divGerar {
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.btn-filtrar {
    color: white;
    border: 3px solid #006f45;
    background-color: #007d4d;
    border-radius: 5em;
    width: 75px;
}

.btn-filtrar:hover {
    color: black;
    border: 3px solid #006f45;
    background-color: #007d4d;
    border-radius: 5em;
}

.form-select {
    width: 22%;
    max-width: 250px;
    border: 3px solid #006f45;
    border-left: none;
    text-align: center;
    border-radius: 0 5em 5em 0;
    color: #FFFFFF;
    background-color: #007d4d;
}

.chamado {
    width: 65%;
}

.lblTelaMenor {
    width: 15%;
    text-align: center;
    margin-right: -4.6%;
    border: 3px solid #006f45;
    border-radius: 5em 0 0 5em;
    border-right: none !important;
    color: #FFFFFF;
    background-color: #007d4d;
}

/*
@media only screen and (min-width:992px) {
    .teste {
        margin-left: 3rem;
    }
}
*/
</style>